import React, { useRef } from 'react'
import lang from '../utils/languageConstant'
import { useDispatch, useSelector } from 'react-redux'
import openai from '../utils/openAi'
import { API_OPTIONS } from '../utils/constants'
import { addGptMovieResult } from '../utils/gptSlice'

const GptSearchBar = () => {

  const dispatch = useDispatch()
const chosenLanguage = useSelector(store=> store.config.lang)
const searchText = useRef(null)

//SEARCH MOVIE IN TMDB DATABASE

const searchMovieTMDB = async (movie) => {
  const data = await fetch(
    "https://api.themoviedb.org/3/search/movie?query=" +
      movie +
      "&include_adult=false&language=en-US&page=1",
    API_OPTIONS
  );
  const json = await data.json();

  return json.results;
}

const handleGptSearchClick = async() => {
   
    const gptQuery = "Act as a Movie recomendation system and suggest some movies for the query" + searchText.current.value + ". only give me names of 5 movies, coma seperated like the example result given ahead. Example Result: Gadar, Sholay, Don, Golmal, Koi Mil Gaya";

    const gptResults = await openai.chat.completions.create({
        messages: [{ role: 'user', content: gptQuery }],
        model: 'gpt-3.5-turbo',
      });

      console.log(gptResults.choices?.[0]?.message?.content);

       if(!gptResults){
console.error("not found");
       }


 const gptMovies = gptResults.choices?.[0]?.message?.content?.split(",")

 //array of movies

// for each movie i will search TMBD API

const promiseArray = gptMovies.map((movie) => searchMovieTMDB(movie) )

//[promise1,promise2,promise3...]

const tmdbResults = await Promise.all(promiseArray);

console.log(tmdbResults);

dispatch((addGptMovieResult({movieNames: gptMovies, movieResults: tmdbResults})));

}


  return (
    <div className='pt-[35%] md:pt-[10%] flex justify-center'>
    
    <form className='w-full md:w-1/2 bg-black grid grid-cols-12' onSubmit={(e)=> e.preventDefault()}>

    <input
    ref={searchText}
     type="text" className='p-4 m-4 col-span-9' placeholder={lang[chosenLanguage].gptSearchPlaceHolder} />
     <button className='col-span-3 m-4 py-2 px-4 bg-red-700 text-white rounded-lg'
     onClick={handleGptSearchClick}
     >{lang[chosenLanguage].search}</button>
 

    </form>

    </div>
  )
}

export default GptSearchBar